<section class="pt-3">
  <screen-support></screen-support>  
</section>

<section class="sfe-safe pt-5 sfe-welcome">
  <h1 class="sfe-welcome-head">Action Plan</h1>
  <p>
   This is your customized Action Plan, created by your assessments, to help you reach your business goals.
    For right now, we can only help. The power is really in your hands. Help us make you proud.
  </p>
  </section>

<nav aria-label="breadcrumb" class="pt-5 ">
  <ol class="breadcrumb">
    <li class="breadcrumb-item " aria-current="page">
      <div *ngIf="authService.isAdmin == false">
        <a routerLink="/entrep-dash">Dashboard</a>
      </div>
      <div *ngIf="authService.isAdmin == true">
        <a routerLink="/admin-dash">Dashboard</a>
      </div>
    </li>
    <li class="breadcrumb-item active" aria-current="page">Action Plan</li>
  </ol>
</nav> 

<section class="pt-5">
  <div class="container-fluid pt-3">
    <mat-card class="pt-3">
      <mat-card-title>Add an Action Plan Below</mat-card-title>
        <div class="pb-5"></div>
        <mat-card-content>
         <form [formGroup]="actionItemFormGroup" (ngSubmit)="addActionItemtoFirestore()" novalidate>
        <div class="row">
          <div class="col">
          
            <mat-form-field>
              <mat-label>Action Item Name</mat-label>
              <input matInput type="text" formControlName="actionItemName">
              <mat-error *ngIf="actionItemFormGroup.controls['actionItemCategory']">
                Enter Action Item
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
          
              <mat-form-field class="full-width">
                <mat-label>Select an Category</mat-label>
                <mat-select placeholder=" " formControlName="actionItemCategory">
                  <mat-option *ngFor="let aItemCategory of actionItemCategory" [value]="aItemCategory">
                    {{ aItemCategory }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="actionItemFormGroup.controls['actionItemCategory']">
                  Please select one
                </mat-error>
              </mat-form-field>
          </div>
          <div class="col">
         
            <mat-form-field>
              <mat-label>Resource</mat-label>
              <input matInput type="text" formControlName="actionItemResource">
            </mat-form-field>    
          </div>
          <div class="col">
         
              <mat-form-field class="full-width">
                <mat-label>Time Frame</mat-label>
                <mat-select placeholder=" " formControlName="actionItemTimeFrame">
                  <mat-option *ngFor="let aItemTimeFrame of actionItemTimeFrame" [value]="aItemTimeFrame">
                    {{ aItemTimeFrame}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="actionItemFormGroup.controls['actionItemTimeFrame']">
                  Please select one
                </mat-error>
              </mat-form-field>
          </div>
          <div class="pr-3">
            <button mat-mini-fab color="primary" [disabled]="!actionItemFormGroup.valid">
              <mat-icon>add</mat-icon>
            </button>
          </div>
      </div>
      </form>
      </mat-card-content>
    </mat-card>
      <div class="pb-3"></div>
    </div>
</section>



<section class="pt-5 white-bg">
  <div class="container-fluid">
    <div class="table-responsive" >
        <table class="table table-striped table-responsive-sm table-responsive-md table-responsive-lg">
          <thead>
            <tr>
              <th scope="col">Item name</th>
              <th scope="col">Category</th>
              <th scope="col">Resource</th>
              <th scope="col">Time Frame</th>
              <th scope="col">Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let actionItem of dataArray |  paginate: { itemsPerPage: 9, currentPage: p }; let i = index;">
              <td>
              <!--*ngIf="!group.get('actionItemIsEditable').value" {{group.get('actionItemName').value}}-->
              {{actionItem.actionItemName}}
              </td>
              <td>{{actionItem.actionItemCategory}}</td>
              
              <td>
              <div *ngIf="null == actionItem.actionItemResourceURL; else resourceNameElse">
                {{actionItem.actionItemResourceName}}
              </div>
              <ng-template #resourceNameElse>
                <a href="{{actionItem.actionItemResourceURL}}" target="_blank"  rel="noopener noreferrer">{{actionItem.actionItemResourceName}} </a>
                </ng-template>
              </td>
              <td>{{actionItem.actionItemTimeFrame}}</td>
              <td>
               <mat-icon class="delete" (click)="remove(actionItem.key)">delete_forever</mat-icon>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    <!-- Pagination -->
    <pagination-controls (pageChange)="p = $event" autoHide="true" responsive="true"></pagination-controls>
  </div>
</section>

